exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Step4-82fd1169{display:flex;margin:30px auto;max-width:500px}.Step4-82fd1169 div{margin:0 20px}.Step4-82fd1169 video{max-height:300px;max-width:169.01408px;box-shadow:2px 2px 4px rgba(0,0,0,0.1)}\n", ""]);

// Exports
exports.locals = {
	"Step4": "Step4-82fd1169"
};